// Source: https://vendorlist.consensu.org/v2/vendor-list.json
export var Purpose;
(function (Purpose) {
    Purpose[Purpose["STORAGE"] = 1] = "STORAGE";
    Purpose[Purpose["SELECT_BASIC_ADS"] = 2] = "SELECT_BASIC_ADS";
    Purpose[Purpose["CREATE_PERSONALISED_ADS_PROFILE"] = 3] = "CREATE_PERSONALISED_ADS_PROFILE";
    Purpose[Purpose["SELECT_PERSONALISED_ADS"] = 4] = "SELECT_PERSONALISED_ADS";
    Purpose[Purpose["CREATE_PERSONALISED_ADS_CONTENT_PROFILE"] = 5] = "CREATE_PERSONALISED_ADS_CONTENT_PROFILE";
    Purpose[Purpose["SELECT_PERSONALISED_CONTENT"] = 6] = "SELECT_PERSONALISED_CONTENT";
    Purpose[Purpose["MEASURE_AD_PERFORMANCE"] = 7] = "MEASURE_AD_PERFORMANCE";
    Purpose[Purpose["MEASURE_CONTENT_PERFORMANCE"] = 8] = "MEASURE_CONTENT_PERFORMANCE";
    Purpose[Purpose["APPLY_MARKET_RESEARCH"] = 9] = "APPLY_MARKET_RESEARCH";
    Purpose[Purpose["DEVELOP_AND_IMPROVE_PRODUCTS"] = 10] = "DEVELOP_AND_IMPROVE_PRODUCTS";
})(Purpose || (Purpose = {}));
//# sourceMappingURL=tcf.js.map